export const EVENT_DATE_TIME_FORMAT = 'MMMM dd, yyyy, hh:mm a';

export const JOB_EVENT_TYPES = {
  ADDED_TO_JOB: 'ADDED_TO_JOB',
  MOVED_STEP: 'MOVED_STEP',
  DISQUALIFIED: 'DISQUALIFIED',
  REQUALIFIED: 'REQUALIFIED',
};
